import { EventEmitter } from 'events';

import { ProjectService } from './../../../services/project.service';
import { TaskService } from './../../../services/task.service';

import { Project } from './../../../classes/project.class';
import { Task } from './../../../classes/task.class';

export class ProjectDetailPageController extends EventEmitter {
    constructor(params) {
        super();

        this.user = params.user;
        this.projectId = params.projectId;
        this.projectService = new ProjectService({apiUrl: params.apiUrl});
        this.taskService = new TaskService({apiUrl: params.apiUrl});
        this.project = null;
        this.tasks = [];

        this.projectService.getProjectById(this.projectId, this.user.id).then(response => {
            this.project = new Project(response.data[0]);
            this.emitProject();
            this.taskService.getProjectTasks(this.user.id, this.project.id).then(response => {
                this.tasks = response.data.map(task => new Task(task));
                console.log(this.project);
                console.log(this.tasks);
                this.emitTasks();
            });
        });
    }

    createProjectTask() {
        this.taskService.postTask({}, this.user, this.project.id).then(response => {
            this.tasks.push(new Task(response.data));
            this.emitTasks();
        });
    }

    updateTask(task) {
        this.taskService.putTask(task, this.user).then(res => {
            console.log(res);

            this.tasks.forEach((task, index) => {
                if(task.id === res.data.id) {
                    this.tasks[index] = new Task(res.data);
                }
            });

            this.emitTasks();
        });
    }

    deleteTask(id) {
        this.taskService.deleteTask(id, this.user).then(res => {
            console.log(res.status);
            console.log(res.status === 200);
            if(res.status === 200) {
                console.log(this.tasks);
                console.log(this.tasks.filter(task => task.id !== id));
                
                this.tasks = this.tasks.filter(task => task.id !== id);
                console.log(this.tasks);
                this.emitTasks();
            }
        });
    }

    getProject() {
        return this.project;
    }

    getTasks() {
        return this.tasks;
    }

    emitProject() {
        this.emit('updateProject');
    }

    emitTasks() {
        this.emit('updateTasks');
    }
}


// WEBPACK FOOTER //
// src/pages/project/detail/project-detail.controller.js